import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { AskPredefinedTemplatesActions } from './predefined-templates.store';
import { TemplatesHttpService } from '../templates/templates-http.service';

@Injectable({ providedIn: 'root' })
export class AskPredefinedTemplatesEffects {
  private readonly actions$ = inject(Actions);
  private readonly templatesHttpService = inject(TemplatesHttpService);

  public fetchPredefined$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AskPredefinedTemplatesActions.fetchPredefined),
      switchMap(() =>
        this.templatesHttpService.fetchPredefinedTemplates().pipe(
          map(data => AskPredefinedTemplatesActions.fetchPredefinedSuccess({ payload: { data } })),
          catchError((error: HttpErrorResponse) =>
            of(AskPredefinedTemplatesActions.fetchPredefinedFailed({ payload: { error } })),
          ),
        ),
      ),
    ),
  );
}
